import { Component, EventEmitter, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  standalone: true,
  selector: 'app-confirmation-modal',
  templateUrl: './confirmation-modal.component.html',
  styleUrls: ['./confirmation-modal.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [ReactiveFormsModule],
})
export class ConfirmationModalComponent implements OnInit {
  @Output() action = new EventEmitter();

  public confirmationMessage: string;
  public confirmationTitle: string;
  public actionLabelBtn: string;
  public disableButton: boolean = false;
  public confirmationInput: boolean = false;
  public confirmationInputText: string = '';

  public confirmationForm: FormGroup;

  public danger: boolean;
  public success: boolean;

  constructor(
    protected bsModalRef: BsModalRef,
    private _formBuilder: FormBuilder,
  ) {}

  public ngOnInit(): void {
    this.confirmationForm = this._formBuilder.group({
      confirmationText: [''],
    });

    if (this.confirmationInput) {
      this.enableConfirmationValidation();
    }
  }

  private enableConfirmationValidation(): void {
    const control = this.confirmationForm.get('confirmationText');

    if (!control) return;

    control.setValidators([Validators.required, this.matchTextValidator(this.confirmationInputText)]);

    control.updateValueAndValidity();
  }

  private matchTextValidator(expected: string) {
    return (control: any) => {
      if (!control.value) return { required: true };

      return control.value === expected ? null : { confirmationMismatch: true };
    };
  }

  public confirm(): void {
    this.action.emit(true);
  }

  public cancel(): void {
    this.action.emit(false);
  }
}
